// Keeps the "Box contents" card (pdp-blocks.liquid, box_contents_item /
// box_contents_intro blocks) in sync with the selected variant. All
// editions' items and supporting text are rendered server-side (hidden via
// [hidden] unless they match the initial variant); this just toggles that
// on the "variant:changed" event so switching edition swatches doesn't need
// a full page reload. The grid/list display itself is a merchant setting
// (box_contents_view), not something this script controls.
document.addEventListener("variant:changed", (event) => {
  const variant = event.detail && event.detail.variant;
  if (!variant) return;

  const options = variant.options || [];

  document.querySelectorAll("[data-box-contents]").forEach((card) => {
    const items = card.querySelectorAll("[data-box-contents-item]");
    let anyVisible = false;

    items.forEach((item) => {
      const edition = item.getAttribute("data-edition");
      const matches = !edition || options.includes(edition);
      item.hidden = !matches;
      if (matches) anyVisible = true;
    });

    card.hidden = !anyVisible;

    card.querySelectorAll("[data-box-contents-intro]").forEach((intro) => {
      const edition = intro.getAttribute("data-edition");
      intro.hidden = Boolean(edition) && !options.includes(edition);
    });
  });

  document.querySelectorAll("[data-box-contents-edition-pill]").forEach((pill) => {
    pill.textContent = variant.title;
  });
});
